export type DetailOption = {
  label: string;
  note?: string;
  price: string;
};

export const brand = {
  name: "ALÉA Aesthetic House",
  shortName: "ALÉA",
  city: "Culiacán",
  state: "Sinaloa",
  tagline: "Belleza clínica, natural y profesional.",
  claim: "Piel cuidada, no transformada en exceso.",
  address: "Blvd. Pedro Infante 1520, Col. Recursos Hidráulicos, Culiacán, Sinaloa",
  phoneDisplay: "+52 667 123 4567",
  email: "hola@aleaaesthetic.com",
  hours: [
    { day: "Lunes a Viernes", time: "9:00 – 20:00" },
    { day: "Sábado", time: "9:00 – 15:00" },
    { day: "Domingo", time: "Cerrado" },
  ],
};

export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Clínica", href: "#clinica" },
  { label: "Productos", href: "#productos" },
  { label: "Cursos", href: "#cursos" },
  { label: "Insumos Pro", href: "#insumos" },
  { label: "Sociedad ALÉA", href: "#sociedad" },
  { label: "Contacto", href: "#contacto" },
];

export const values = [
  {
    icon: "ri-contrast-drop-2-line",
    title: "Resultados naturales",
    text: "Tratamientos que armonizan, sin transformar en exceso.",
  },
  {
    icon: "ri-stethoscope-line",
    title: "Belleza clínica",
    text: "Valoración previa, protocolos seguros y acompañamiento real.",
  },
  {
    icon: "ri-leaf-line",
    title: "Piel cuidada de verdad",
    text: "Belleza consciente, sin promesas exageradas.",
  },
];

export const about = {
  eyebrow: "Quiénes somos",
  title: "Una casa estética integral",
  lead: "ALÉA nace como una casa estética integral en Culiacán: clínica, skincare, formación profesional e insumos especializados.",
  paragraphs: [
    "Un ecosistema diseñado para cuidar la piel, elevar técnicas y construir comunidad.",
    "Cada protocolo inicia con una valoración honesta. Trabajamos con criterio clínico y resultados que respetan tu rostro y tu piel.",
  ],
  stats: [
    { value: "+8", label: "años de experiencia clínica" },
    { value: "+3,000", label: "tratamientos realizados" },
    { value: "5", label: "unidades en un ecosistema" },
  ],
};

export const tips = [
  {
    icon: "ri-sun-line",
    title: "Protege tu piel diario",
    label: "Uso diario",
    text: "Protector solar todos los días, incluso en interiores.",
  },
  {
    icon: "ri-drop-line",
    title: "Hidrata después de tratamientos",
    label: "Post-tratamiento",
    text: "Sella la hidratación y respeta los días de recuperación.",
  },
  {
    icon: "ri-shield-cross-line",
    title: "No mezcles activos sin asesoría",
    label: "Alerta",
    text: "Combinar ácidos y retinoides sin guía irrita la piel.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Agenda valoración antes",
    label: "Antes de agendar",
    text: "Una valoración honesta define el protocolo correcto.",
  },
];

export const promotions = [
  {
    name: "Ritual Glow de temporada",
    tagline: "Limpieza profunda + aparatología para piel luminosa.",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20beauty%20close%20up%20of%20a%20woman%20with%20fresh%20glowing%20skin%20on%20a%20soft%20warm%20white%20studio%20background%2C%20hygienic%20clinical%20skincare%20campaign%20photography%2C%20natural%20light%2C%20minimal%20modern%20aesthetic%2C%20no%20text&width=1000&height=1200&seq=aleaW-promo-glow&orientation=portrait&nocache=true",
    badge: "Oferta activa",
    tone: "gold",
    promoPrice: "$1,290",
    regularPrice: "$1,890",
    valid: "Vigente todo septiembre 2026",
    description:
      "Un protocolo completo para reiniciar tu piel en una sola sesión: diagnóstico, limpieza profunda, activos y aparatología para sellar luminosidad.",
    benefits: [
      "Diagnóstico de piel incluido",
      "Limpieza profunda + aparatología",
      "Rutina ALÉA Skin de regalo",
    ],
    conditions: ["Válido presentando este banner", "No acumulable con otras promociones", "Sujeto a valoración previa"],
  },
  {
    name: "Pack Botox + Skin",
    tagline: "Armonización de líneas de expresión + skincare profesional.",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20beauty%20portrait%20of%20a%20serene%20woman%20with%20smooth%20natural%20skin%20on%20a%20soft%20warm%20white%20studio%20background%2C%20modern%20clinical%20aesthetic%20photography%2C%20soft%20natural%20light%2C%20minimal%20and%20elegant%2C%20no%20text&width=1000&height=1200&seq=aleaW-promo-botox&orientation=portrait&nocache=true",
    badge: "Cupos limitados",
    tone: "dark",
    promoPrice: "$3,490",
    regularPrice: "$4,400",
    valid: "Cupo limitado por semana",
    description:
      "Combinamos la aplicación de Botox con un kit de mantenimiento ALÉA Skin para que el resultado se vea mejor y dure más.",
    benefits: [
      "Aplicación de una zona de botox",
      "Kit Glow Inicial de 4 pasos",
      "Seguimiento a los 15 días",
    ],
    conditions: ["Requiere valoración previa", "Cupo limitado por semana", "Anticipo del 30% para apartar"],
  },
  {
    name: "Semana de Labios",
    tagline: "Diseño y perfilado con efecto natural.",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20close%20up%20of%20naturally%20soft%20defined%20lips%20on%20a%20soft%20warm%20white%20studio%20background%2C%20modern%20clinical%20beauty%20photography%2C%20soft%20even%20daylight%2C%20minimal%20elegant%20aesthetic%2C%20no%20text&width=1000&height=1200&seq=aleaW-promo-lips&orientation=portrait&nocache=true",
    badge: "Solo esta semana",
    tone: "warm",
    promoPrice: "$2,990",
    regularPrice: "$3,600",
    valid: "Del 8 al 15 de octubre",
    description:
      "Diseñamos el labio desde la proporción de tu rostro con técnica de perfilado e hidratación. Efecto natural y con seguimiento incluido.",
    benefits: [
      "Diseño previo de proporción labial",
      "Anestesia tópica incluida",
      "Retoque a los 15 días",
    ],
    conditions: ["Fechas limitadas del 8 al 15 de octubre", "Sujeto a disponibilidad de agenda", "No acumulable con combos"],
  },
];

export const clinicalServices = [
  {
    featured: true,
    icon: "ri-focus-3-line",
    category: "Inyectables",
    name: "Botox / Baby Botox",
    badge: "Más solicitado",
    text: "Suavizado de líneas de expresión manteniendo la naturalidad del gesto.",
    duration: "30 min",
    price: "Desde $2,400",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20clinical%20beauty%20portrait%20of%20a%20woman%20with%20smooth%20natural%20skin%20on%20a%20soft%20warm%20white%20background%2C%20modern%20aesthetic%20clinic%20photography%2C%20fresh%20natural%20light%2C%20minimal%20and%20hygienic%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-botox&orientation=portrait&nocache=true",
    description:
      "Relajamos la musculatura que marca las líneas de expresión para que el rostro se vea descansado sin perder movimiento. Trabajamos dosis conservadoras y priorizamos que sigas viéndote como tú.",
    optionsTitle: "Zonas y dosis",
    options: [
      { label: "Zona única", note: "Entrecejo o una sola área", price: "$2,400" },
      { label: "Frente + entrecejo", note: "Dos zonas armónicas", price: "$3,600" },
      { label: "Full face", note: "Frente, entrecejo y patas de gallo", price: "$4,800" },
    ],
    benefits: [
      "Valoración previa de expresión facial",
      "Técnica de dosis conservadora",
      "Indicaciones de cuidado posteriores",
    ],
  },
  {
    featured: true,
    icon: "ri-heart-3-line",
    category: "Inyectables",
    name: "Relleno y diseño de labios",
    badge: "Alta demanda",
    text: "Proyección y definición a medida, respetando tu anatomía.",
    duration: "45 min",
    price: "Desde $3,600",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20close%20up%20of%20naturally%20defined%20soft%20lips%20on%20a%20soft%20warm%20white%20background%2C%20modern%20clinical%20aesthetic%20photography%2C%20soft%20even%20daylight%2C%20minimal%20elegant%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-lips&orientation=portrait&nocache=true",
    description:
      "Diseñamos el labio desde la proporción de tu rostro: hidratación, perfilado o proyección sutil. Buscamos un efecto natural y proporcional a tu anatomía.",
    optionsTitle: "Nivel de proyección",
    options: [
      { label: "Hidratación y perfilado", note: "0.5 ml, efecto natural", price: "$3,600" },
      { label: "Proyección", note: "1 ml, volumen armónico", price: "$5,400" },
      { label: "Retoque", note: "A los 15 días del tratamiento", price: "$1,200" },
    ],
    benefits: [
      "Diseño previo de proporción labial",
      "Anestesia tópica incluida",
      "Seguimiento del resultado a los 15 días",
    ],
  },
  {
    featured: true,
    icon: "ri-drop-line",
    category: "Bioestimulación",
    name: "PRP / Plasma rico en plaquetas",
    badge: "Bioestimulación",
    text: "Bioestimulación con tu propia sangre para calidad de piel.",
    duration: "60 min",
    price: "Desde $2,800",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20clinical%20still%20life%20of%20a%20sterile%20serum%20vial%20and%20gloved%20hand%20on%20a%20white%20surface%2C%20modern%20medical%20aesthetic%20setting%2C%20soft%20natural%20light%2C%20minimal%20hygienic%20composition%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-prp&orientation=portrait&nocache=true",
    description:
      "Usamos tu propio plasma para estimular colágeno y mejorar textura, luminosidad y firmeza. Es un tratamiento biológico, seguro y progresivo.",
    optionsTitle: "Protocolos",
    options: [
      { label: "Facial · 1 sesión", note: "Bioestimulación inicial", price: "$2,800" },
      { label: "Facial · 3 sesiones", note: "Protocolo completo de colágeno", price: "$7,500" },
      { label: "Capilar · 1 sesión", note: "Fortalece el folículo", price: "$3,200" },
    ],
    benefits: [
      "Toma de muestra y preparación del plasma",
      "Aplicación con técnica estéril",
      "Protocolo de recuperación en casa",
    ],
  },
  {
    featured: true,
    icon: "ri-sparkling-2-line",
    category: "Faciales",
    name: "Faciales profesionales",
    badge: "Favorito",
    text: "Limpieza profunda, hidratación y protocolos según tu tipo de piel.",
    duration: "75 min",
    price: "Desde $950",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20photo%20of%20a%20woman%20receiving%20a%20professional%20facial%20treatment%20on%20a%20soft%20white%20background%2C%20modern%20aesthetic%20clinic%2C%20fresh%20natural%20light%2C%20calm%20minimal%20hygienic%20mood%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-facial&orientation=portrait&nocache=true",
    description:
      "El facial se diseña según lo que tu piel necesita ese día: diagnóstico, limpieza, activos y masaje. Terminas con la barrera cutánea cuidada y una rutina clara para casa.",
    optionsTitle: "Protocolos de facial",
    options: [
      { label: "Limpieza profunda", note: "Extracción y calma", price: "$950" },
      { label: "Hidratante con aparatología", note: "Con radiofrecuencia suave", price: "$1,450" },
      { label: "Anti-edad premium", note: "Activos, vitaminas y masaje lifting", price: "$1,890" },
    ],
    benefits: [
      "Diagnóstico de piel incluido",
      "Activos según tu tipo de piel",
      "Recomendación de rutina ALÉA Skin",
    ],
  },
  {
    featured: true,
    icon: "ri-leaf-line",
    category: "Corporal",
    name: "Lipoenzimas",
    badge: "",
    text: "Reducción localizada con acompañamiento y seguimiento clínico.",
    duration: "45 min",
    price: "Desde $1,600",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20clinical%20still%20life%20of%20a%20sterile%20treatment%20tray%20with%20instruments%20on%20a%20white%20surface%2C%20modern%20medical%20aesthetic%20setting%2C%20soft%20natural%20light%2C%20minimal%20hygienic%20composition%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-lipo&orientation=portrait&nocache=true",
    description:
      "Aplicamos enzimas que actúan sobre grasa localizada en zonas puntuales, siempre con valoración y pauta de sesiones para que el resultado se mantenga.",
    optionsTitle: "Zonas y paquetes",
    options: [
      { label: "1 zona", note: "Abdomen, flancos o brazos", price: "$1,600" },
      { label: "2 zonas", note: "Aplicación combinada", price: "$2,900" },
      { label: "Paquete 4 sesiones", note: "Resultado progresivo", price: "$5,600" },
    ],
    benefits: [
      "Valoración de la zona a tratar",
      "Medición inicial para seguimiento",
      "Pauta nutricional básica de apoyo",
    ],
  },
  {
    featured: true,
    icon: "ri-pulse-line",
    category: "Aparatología",
    name: "Aparatología estética",
    badge: "",
    text: "Radiofrecuencia, HIFU y tecnología para firmeza y textura.",
    duration: "60 min",
    price: "Desde $1,800",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20still%20life%20of%20a%20modern%20aesthetic%20skin%20care%20device%20on%20a%20white%20surface%2C%20professional%20clinical%20technology%2C%20soft%20natural%20light%2C%20minimal%20hygienic%20modern%20composition%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-aparato&orientation=portrait&nocache=true",
    description:
      "Tecnología no invasiva para tensar, reafirmar y mejorar textura sin tiempo de recuperación. Combinamos radiofrecuencia y HIFU según el objetivo.",
    optionsTitle: "Tecnología",
    options: [
      { label: "Radiofrecuencia facial", note: "Firmeza y luminosidad", price: "$1,800" },
      { label: "HIFU lifting", note: "Tensado de capas profundas", price: "$3,400" },
      { label: "Paquete 4 sesiones", note: "Protocolo de reafirmación", price: "$6,200" },
    ],
    benefits: [
      "Diagnóstico y plan de sesiones",
      "Aplicación con equipo profesional",
      "Seguimiento fotográfico del progreso",
    ],
  },
  {
    featured: false,
    icon: "ri-emotion-happy-line",
    category: "Contorno",
    name: "Lipopapada",
    badge: "",
    text: "Definición del contorno mandibular y reducción submentoniana.",
    duration: "40 min",
    price: "Desde $2,200",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20beauty%20profile%20portrait%20of%20a%20woman%20with%20a%20defined%20jawline%20on%20a%20soft%20warm%20white%20background%2C%20modern%20clinical%20aesthetic%20photography%2C%20soft%20natural%20light%2C%20minimal%20elegant%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-lipopapada&orientation=portrait&nocache=true",
    description:
      "Reducimos la grasa bajo el mentón para definir el contorno facial y afinar la línea mandibular. Resultado natural y progresivo, sin cirugía.",
    optionsTitle: "Sesiones",
    options: [
      { label: "Sesión única", note: "Aplicación inicial", price: "$2,200" },
      { label: "Dos sesiones", note: "Definición progresiva", price: "$3,900" },
    ],
    benefits: [
      "Evaluación del contorno facial",
      "Aplicación localizada y estéril",
      "Recomendaciones de cuidado post",
    ],
  },
  {
    featured: false,
    icon: "ri-seedling-line",
    category: "Bienestar",
    name: "Aromaterapia y bienestar",
    badge: "",
    text: "Rituales sensoriales que calman el sistema y elevan la experiencia.",
    duration: "50 min",
    price: "Desde $850",
    image:
      "https://readdy.ai/api/search-image?query=Bright%20clean%20still%20life%20of%20clear%20essential%20oil%20bottles%20with%20fresh%20botanicals%20on%20a%20white%20surface%2C%20modern%20wellness%20aesthetic%2C%20soft%20natural%20light%2C%20minimal%20hygienic%20composition%2C%20no%20text&width=900&height=1100&seq=aleaW-svc-aroma&orientation=portrait&nocache=true",
    description:
      "Un ritual de calma que combina aromaterapia, masaje y respiración para bajar el estrés y elevar tu bienestar. Perfecto para complementar cualquier protocolo de piel.",
    optionsTitle: "Rituales",
    options: [
      { label: "Ritual express", note: "50 minutos", price: "$850" },
      { label: "Ritual completo", note: "80 minutos con masaje profundo", price: "$1,250" },
    ],
    benefits: [
      "Aceites esenciales según objetivo",
      "Masaje relajante de rostro y cuello",
      "Ambientación sensorial completa",
    ],
  },
];

export const skinProducts = [
  {
    name: "Protector Solar SPF 50",
    flag: "Más vendido",
    category: "Protección",
    benefit: "Protección diaria sin residuo blanco.",
    price: "$620",
    tag: "Esencial",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20matte%20sunscreen%20tube%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-sunscreen&orientation=squarish&nocache=true",
    description:
      "Fórmula ligera de amplio espectro que protege sin sensación grasosa ni residuo blanco. Textura que se absorbe rápido, perfecta bajo el maquillaje.",
    indication: "Uso diario por la mañana, último paso de tu rutina. Reaplica cada 3 horas al exponerte al sol.",
    optionsTitle: "Presentación",
    options: [
      { label: "50 ml", note: "Tamaño estándar", price: "$620" },
      { label: "50 ml × 2", note: "Pack de reposición", price: "$1,120" },
    ],
  },
  {
    name: "Sérum Ácido Hialurónico",
    flag: "",
    category: "Hidratación",
    benefit: "Hidratación profunda y efecto plump inmediato.",
    price: "$780",
    tag: "Hidratación",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20dropper%20serum%20bottle%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-hyaluronic&orientation=squarish&nocache=true",
    description:
      "Concentrado de ácido hialurónico de varios pesos moleculares que atrae y retiene agua en distintas capas de la piel. Rellena líneas finas de deshidratación.",
    indication: "Aplica 3-4 gotas sobre piel limpia y húmeda, mañana y noche, antes de tu crema hidratante.",
    optionsTitle: "Presentación",
    options: [
      { label: "30 ml", note: "Uso individual", price: "$780" },
      { label: "30 ml × 2", note: "Pack de reposición", price: "$1,420" },
    ],
  },
  {
    name: "Crema Hidratante Intensiva",
    flag: "Favorito",
    category: "Hidratación",
    benefit: "Barrera nutrida con textura ligera de día y noche.",
    price: "$690",
    tag: "Favorito",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20ceramic%20cream%20jar%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-moisturizer&orientation=squarish&nocache=true",
    description:
      "Hidratación equilibrada con ceramidas y mantecas que fortalecen la barrera de la piel sin tapar el poro. La base perfecta para sellar tus sérums.",
    indication: "Aplica después del sérum, mañana y noche, con suaves movimientos ascendentes.",
    optionsTitle: "Presentación",
    options: [
      { label: "50 ml", note: "Uso individual", price: "$690" },
      { label: "50 ml × 2", note: "Pack de reposición", price: "$1,260" },
    ],
  },
  {
    name: "Sérum Niacinamida",
    flag: "",
    category: "Tratamiento",
    benefit: "Unifica el tono y regula la textura de la piel.",
    price: "$720",
    tag: "Tonificante",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20small%20clear%20serum%20vial%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-niacinamide&orientation=squarish&nocache=true",
    description:
      "Niacinamida al 10% que ayuda a unificar el tono, controlar el sebo y afinar la textura. Ideal para piel mixta, con marcas o poros visibles.",
    indication: "Aplica por la noche sobre piel limpia, 3 a 4 veces por semana para empezar.",
    optionsTitle: "Presentación",
    options: [
      { label: "30 ml", note: "Uso individual", price: "$720" },
      { label: "30 ml × 2", note: "Pack de reposición", price: "$1,320" },
    ],
  },
  {
    name: "Limpiador Facial",
    flag: "",
    category: "Rutina",
    benefit: "Paso uno: limpio, calmado y sin tirantez.",
    price: "$540",
    tag: "Rutina",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20matte%20cleanser%20bottle%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-cleanser&orientation=squarish&nocache=true",
    description:
      "Gel-crema suave que elimina impurezas, sebo y residuos de protector solar sin alterar el pH. Deja la piel cómoda, no tirante.",
    indication: "Mañana y noche, masajea sobre el rostro húmedo y enjuaga con agua tibia.",
    optionsTitle: "Presentación",
    options: [
      { label: "200 ml", note: "Uso individual", price: "$540" },
      { label: "200 ml × 2", note: "Pack de reposición", price: "$980" },
    ],
  },
  {
    name: "Exfoliante Enzimático",
    flag: "",
    category: "Renovación",
    benefit: "Renueva sin irritar. Piel suave y luminosa.",
    price: "$610",
    tag: "Renovación",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20frosted%20glass%20exfoliant%20jar%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-exfoliant&orientation=squarish&nocache=true",
    description:
      "Exfoliación con enzimas de papaya y piña que disuelve células muertas sin frotar. Renueva la piel respetando su sensibilidad.",
    indication: "Una a dos veces por semana, sobre piel limpia y seca. Evita el contorno de ojos.",
    optionsTitle: "Presentación",
    options: [
      { label: "100 ml", note: "Uso individual", price: "$610" },
      { label: "100 ml × 2", note: "Pack de reposición", price: "$1,100" },
    ],
  },
  {
    name: "Contorno de Ojos",
    flag: "",
    category: "Detalle",
    benefit: "Mirada descansada, menos ojeras y líneas finas.",
    price: "$580",
    tag: "Detalle",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20slim%20eye%20contour%20tube%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-eyecontour&orientation=squarish&nocache=true",
    description:
      "Contorno con cafeína y péptidos que atenúa bolsas y ojeras, e hidrata la zona más delicada del rostro descongestionándola.",
    indication: "Aplica una pequeña cantidad con el dedo anular, mañana y noche, hasta absorber.",
    optionsTitle: "Presentación",
    options: [
      { label: "15 ml", note: "Uso individual", price: "$580" },
      { label: "15 ml × 2", note: "Pack de reposición", price: "$1,060" },
    ],
  },
  {
    name: "Mascarilla Calmante",
    flag: "",
    category: "Calma",
    benefit: "Alivio para piel sensible o post-tratamiento.",
    price: "$590",
    tag: "Calma",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20matte%20mask%20tube%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-mask&orientation=squarish&nocache=true",
    description:
      "Mascarilla de textura fresca con aloe, avena y pantenol que calma enrojecimiento y sensación de ardor después de un tratamiento o en piel reactiva.",
    indication: "Aplica una capa uniforme por 15 minutos y retira con agua tibia. Úsala 1-2 veces por semana.",
    optionsTitle: "Presentación",
    options: [
      { label: "150 ml", note: "Uso individual", price: "$590" },
      { label: "150 ml × 2", note: "Pack de reposición", price: "$1,070" },
    ],
  },
  {
    name: "Recuperación Post-Tratamiento",
    flag: "",
    category: "Post-tratamiento",
    benefit: "El protocolo que protege tu inversión en clínica.",
    price: "$840",
    tag: "Post-tratamiento",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20product%20photography%20of%20a%20recovery%20cream%20jar%20centered%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-postcare&orientation=squarish&nocache=true",
    description:
      "Bálsamo reparador con activos antiinflamatorios que acelera la recuperación después de inyectables, aparatología o faciales profundos.",
    indication: "Aplica la primera semana post-tratamiento, mañana y noche, sobre piel limpia y seca.",
    optionsTitle: "Presentación",
    options: [
      { label: "50 ml", note: "Uso individual", price: "$840" },
      { label: "50 ml × 2", note: "Pack de reposición", price: "$1,540" },
    ],
  },
  {
    name: "Kit Glow Inicial",
    flag: "Kit estrella",
    category: "Kit",
    benefit: "Cuatro pasos para empezar tu rutina con sentido.",
    price: "$1,980",
    tag: "Kit",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20premium%20skincare%20gift%20set%20photography%20with%20four%20elegant%20bottles%20arranged%20on%20a%20soft%20warm%20white%20seamless%20background%20with%20a%20gentle%20shadow%2C%20modern%20clinical%20ecommerce%20still%20life%2C%20minimal%20and%20bright%2C%20no%20text&width=900&height=900&seq=aleaW-skin-kitglow&orientation=squarish&nocache=true",
    description:
      "Tu rutina completa en cuatro pasos: limpiador, sérum de ácido hialurónico, crema hidratante y protector solar. La forma más simple de empezar bien.",
    indication: "Sigue el orden del Kit cada mañana y noche para una piel hidratada y protegida.",
    optionsTitle: "Composición del kit",
    options: [
      { label: "Kit esencial", note: "Limpia, hidrata y protege", price: "$1,980" },
      { label: "Kit completo", note: "Suma niacinamida y contorno de ojos", price: "$2,760" },
    ],
  },
];

export const beforeAfter = [
  {
    title: "Textura y luminosidad",
    protocol: "PRP · 3 sesiones",
    before:
      "https://readdy.ai/api/search-image?query=Clinical%20dermatology%20before%20close%20up%20of%20a%20woman%20cheek%20skin%20with%20visible%20texture%20and%20uneven%20tone%20on%20a%20clean%20light%20grey%20background%2C%20soft%20even%20clinical%20light%2C%20documentary%20medical%20photography%2C%20no%20text&width=800&height=900&seq=aleaW-ba1-before&orientation=squarish&nocache=true",
    after:
      "https://readdy.ai/api/search-image?query=Clinical%20dermatology%20after%20close%20up%20of%20a%20woman%20cheek%20skin%20with%20smooth%20even%20glowing%20tone%20on%20a%20clean%20light%20grey%20background%2C%20soft%20even%20clinical%20light%2C%20documentary%20medical%20photography%2C%20no%20text&width=800&height=900&seq=aleaW-ba1-after&orientation=squarish&nocache=true",
  },
  {
    title: "Definición de labios",
    protocol: "Relleno y diseño",
    before:
      "https://readdy.ai/api/search-image?query=Clinical%20before%20close%20up%20of%20thin%20undefined%20lips%20on%20a%20clean%20light%20grey%20background%2C%20soft%20even%20clinical%20light%2C%20documentary%20medical%20beauty%20photography%2C%20no%20text&width=800&height=900&seq=aleaW-ba2-before&orientation=squarish&nocache=true",
    after:
      "https://readdy.ai/api/search-image?query=Clinical%20after%20close%20up%20of%20naturally%20defined%20balanced%20lips%20on%20a%20clean%20light%20grey%20background%2C%20soft%20even%20clinical%20light%2C%20documentary%20medical%20beauty%20photography%2C%20no%20text&width=800&height=900&seq=aleaW-ba2-after&orientation=squarish&nocache=true",
  },
  {
    title: "Contorno y firmeza",
    protocol: "Aparatología · 4 sesiones",
    before:
      "https://readdy.ai/api/search-image?query=Clinical%20before%20profile%20close%20up%20of%20a%20soft%20undefined%20jawline%20on%20a%20clean%20light%20grey%20background%2C%20soft%20even%20clinical%20light%2C%20documentary%20medical%20beauty%20photography%2C%20no%20text&width=800&height=900&seq=aleaW-ba3-before&orientation=squarish&nocache=true",
    after:
      "https://readdy.ai/api/search-image?query=Clinical%20after%20profile%20close%20up%20of%20a%20defined%20firm%20jawline%20on%20a%20clean%20light%20grey%20background%2C%20soft%20even%20clinical%20light%2C%20documentary%20medical%20beauty%20photography%2C%20no%20text&width=800&height=900&seq=aleaW-ba3-after&orientation=squarish&nocache=true",
  },
];

export const courses = [
  {
    title: "Faciales Profesionales",
    date: "12 – 13 Oct 2026",
    duration: "16 hrs",
    spots: "4 lugares",
    level: "Inicial · Presencial",
    text: "Diagnóstico de piel, protocolos de limpieza profunda y aparatología básica.",
  },
  {
    title: "Aplicación de Botox",
    date: "26 – 27 Oct 2026",
    duration: "18 hrs",
    spots: "3 lugares",
    level: "Intermedio · Presencial",
    text: "Anatomía, puntos de aplicación seguros y manejo de complicaciones.",
  },
  {
    title: "Diseño y Relleno de Labios",
    date: "9 – 10 Nov 2026",
    duration: "18 hrs",
    spots: "4 lugares",
    level: "Intermedio · Presencial",
    text: "Proporción, técnica de proyección y resultado natural del tercio inferior.",
  },
  {
    title: "Aparatología Estética",
    date: "23 Nov 2026",
    duration: "10 hrs",
    spots: "6 lugares",
    level: "Inicial · Presencial",
    text: "Radiofrecuencia, HIFU y protocolos de firmeza con práctica supervisada.",
  },
  {
    title: "Protocolos Post-Tratamiento",
    date: "7 Dic 2026",
    duration: "8 hrs",
    spots: "8 lugares",
    level: "Inicial · Presencial",
    text: "Seguimiento, recuperación y recomendación de rutina en casa.",
  },
  {
    title: "Lipoenzimas",
    date: "14 Dic 2026",
    duration: "12 hrs",
    spots: "5 lugares",
    level: "Intermedio · Presencial",
    text: "Valoración, zonas de aplicación y acompañamiento del paciente.",
  },
];

export const courseRequirements = [
  "Constancia o formación previa en estética o salud",
  "Documentación vigente al momento del registro",
  "Anticipo del 30% para apartar tu lugar",
  "Cupo limitado por generación",
];

export const supplyCategories = [
  {
    icon: "ri-goblet-2-line",
    name: "Galones y volumen",
    text: "Productos base por volumen para uso continuo en cabina.",
  },
  {
    icon: "ri-hand-sanitizer-line",
    name: "Consumibles de cabina",
    text: "Guantes, gasas, jeringas, cánulas y material desechable.",
  },
  {
    icon: "ri-flask-line",
    name: "Productos profesionales",
    text: "Activos, anestésicos tópicos y dermocosmética de marca.",
  },
  {
    icon: "ri-briefcase-4-line",
    name: "Kits para cabina",
    text: "Paquetes listos para abrir tu espacio o renovarlo.",
  },
  {
    icon: "ri-test-tube-line",
    name: "Insumos para tratamientos",
    text: "Todo lo necesario para faciales, inyectables y aparatología.",
  },
  {
    icon: "ri-cpu-line",
    name: "Aparatología y accesorios",
    text: "Equipos, puntas y refacciones para tecnológicas estéticas.",
  },
];

export const societyBenefits = [
  { icon: "ri-calendar-event-line", text: "Eventos exclusivos para socias" },
  { icon: "ri-group-line", text: "Networking profesional en Culiacán" },
  { icon: "ri-discount-percent-line", text: "Descuentos en cursos y talleres" },
  { icon: "ri-box-3-line", text: "Acceso preferente a insumos" },
  { icon: "ri-graduation-cap-line", text: "Capacitaciones continuas" },
  { icon: "ri-community-line", text: "Comunidad profesional activa" },
  { icon: "ri-briefcase-line", text: "Bolsa de oportunidades y colaboraciones" },
];

export const ecosystemUnits = [
  { index: "01", name: "Clínica", label: "ALÉA Clínica", href: "#clinica" },
  { index: "02", name: "Skin", label: "ALÉA Skin", href: "#productos" },
  { index: "03", name: "Academy", label: "ALÉA Academy", href: "#cursos" },
  { index: "04", name: "Pro Supply", label: "ALÉA Pro Supply", href: "#insumos" },
  { index: "05", name: "Sociedad", label: "Sociedad ALÉA", href: "#sociedad" },
];